import React, { useEffect, useRef, useState } from "react";
import ReactDatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import "../Styles/BackgroundInfoSection.css";
import { subYears } from "date-fns";

export default function BackgroundInfoSection({
  dob,
  setDob,
  countryList,
  addresDet,
  handelAddreesDet,
  communityList,
  selectedResidence,
  handleResidence,
  selectedCitizenship,
  handleCitizenship,
  seletedEthinicity,
  handleEthinicity,
  postalcode,
  handlePostalcode,
}) {
  const [open, setOpen] = useState(false);
  const datePickerRef = useRef();

  const handleIconClick = (e) => {
    e.stopPropagation(); // prevent closing
    setOpen(true); // manually open the picker
  };

  // console.log("selectedResidence",selectedResidence);

  const [Loading, setLoading] = useState(false);

  return (
    <section className="background-section">
      <header className="background-section__header">
        <h2 className="background-section__title">Background Information</h2>
        <div className="background-section__divider" />
      </header>

      <div className="background-section__row">
        <label className="background-section__label" htmlFor="dob">
          Enter Date of Birth *
        </label>

        <div
          className="date-input-wrapper"
          style={{ cursor: "pointer" }}
          onClick={handleIconClick}
        >
          <ReactDatePicker
            ref={datePickerRef}
            selected={dob}
            onChange={(date) => {
              setDob(date);
              setOpen(false); // close after selection
            }}
            onClickOutside={() => setOpen(false)}
            open={open}
            dateFormat="dd-MM-yyyy"
            placeholderText="dd-mm-yyyy"
            className="custom-date-input"
            maxDate={subYears(new Date(), 18)}
            showMonthDropdown
            showYearDropdown
            dropdownMode="select"
          />

          <img
            className="calender-icon"
            src={require("../assests/images/calender-icon.png")}
            alt="calendar"
          />
        </div>
      </div>

      <div className="cpf-title mb-4">Address</div>
      <div className="background-section__row">
        <label className="background-section__label mt-3" htmlFor="homeTown">
          Enter Address Details *
        </label>

        <input
          name="AddressDetails"
          placeholder="Address Details"
          className="background-section__input"
          value={addresDet}
          onChange={handelAddreesDet}
        />

        <label className="background-section__label mt-3" htmlFor="homeTown">
          Select Residence *
        </label>

        {/* Residence Dropdown */}
        <select
          className="background-section__input"
          value={selectedResidence}
          onChange={handleResidence}
        >
          <option value="">Select Residence</option>
          {countryList?.map((contry) => (
            <option key={contry.id} value={contry.id}>
              {contry.CountryName} ( {contry.CountryCode} )
            </option>
          ))}
        </select>
        {/* Citizenship Citizenship */}
        <label className="background-section__label mt-3" htmlFor="homeTown">
          Select Citizenship *
        </label>
        <select
          className="background-section__input"
          value={selectedCitizenship}
          onChange={handleCitizenship}
        >
          <option value="">Select Citizenship</option>
          {countryList?.map((contry) => (
            <option key={contry.id} value={contry.id}>
              {contry.CountryName} ( {contry.CountryCode} )
            </option>
          ))}
        </select>
        {/* Ethinicity DropDown */}

        <label className="background-section__label mt-3" htmlFor="homeTown">
          Select Ethinicity
        </label>
        <select
          className="background-section__input"
          value={seletedEthinicity}
          onChange={handleEthinicity}
        >
          <option value="">Select Ethinicity</option>
          {communityList?.map((city) => (
            <option key={city.CommunitiesId} value={city.CommunitiesId}>
              {city.CommunitiesName}
            </option>
          ))}
        </select>
        <label className="background-section__label mt-3" htmlFor="homeTown">
          Enter Postal Code
        </label>
        <input
          type="text"
          value={postalcode}
          onChange={handlePostalcode}
          className="background-section__input"
          placeholder=" Enter Postal Code"
        />
      </div>
    </section>
  );
}
